import { useRef } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router'
import toast from 'react-hot-toast'
import Modal from '../../../components/common/Modal'
import { api, apiHeaders } from '../../../configs/api'
import { useAuth } from '../../../context/AuthContext'
import { ProductDetailType, useProduct } from '../../../context/ProductContext'

const ProductDelete = ({
    open,
    handleClose,
    data
}: {
    open: boolean
    handleClose: () => void
    data: ProductDetailType | null
}) => {
    const { unity, token } = useAuth()
    const { loadProducts } = useProduct()
    const form = useForm()
    const formRef = useRef<HTMLFormElement>(null)
    const navigate = useNavigate()

    const handleDelete = async () => {
        if (!data || !unity || !token) return

        try {
            const response = await fetch(`${api}product/delete`, {
                method: 'POST',
                headers: apiHeaders(token),
                body: JSON.stringify({ id: data.product.id, unityID: unity.unityID })
            })
            const result = await response.json()
            if (!response.ok || !result.success) throw new Error(result.message)

            await loadProducts()
            toast.success(result.message)
            navigate('/produto')
        } catch (error) {
            toast.error(error instanceof Error && error.message ? error.message : 'Erro ao excluir produto!')
        } finally {
            handleClose()
        }
    }

    if (!open || !data) return null
    const canDelete = data.business.length === 0

    return (
        <Modal
            open={open}
            handleClose={handleClose}
            title='Excluir produto'
            maxWidth='max-w-xl'
            handleDelete={() => formRef.current?.requestSubmit()}
            canDelete={canDelete}
        >
            <form ref={formRef} onSubmit={form.handleSubmit(handleDelete)}>
                <div className='text-sm text-gray-800 dark:text-white/90'>
                    {canDelete ? (
                        <p>
                            Tem certeza que deseja excluir <strong className='text-error-400'>{data.product.name}</strong>?
                            Esta ação é irreversível.
                        </p>
                    ) : (
                        <p>
                            Este produto possui <strong className='text-error-400'>{data.business.length}</strong>{' '}
                            {data.business.length === 1 ? 'negócio vinculado' : 'negócios vinculados'} e não pode ser
                            excluído.
                        </p>
                    )}
                </div>
            </form>
        </Modal>
    )
}

export default ProductDelete
